<template>
  <div>
    <div class="h-full py-4 pl-4">
      <div class="">
        <h2 class="fsize16 font-semibold pb-1">Our Latest Blogs</h2>
        <div v-if="filteredBlogs.length">
          <div class="" v-for="blog in filteredBlogs" :key="blog._id">
            <p class="fsize13 lh16px pb-2 clr-0087d4 cursor-pointer">
              <a
                href="javascript:void(0)"
                class="text-decoration-none"
                @click="readFullBlogs(blog)"
              >
                {{ blog.title }}
              </a>
            </p>
          </div>
          <p
            class="fsize13 lh16px pb-2 text-primary cursor-pointer"
            @click="toggleBlogView"
          >
            {{ showLessBlogEnable ? "View More" : "Show Less" }}
          </p>
        </div>
      </div>
      <div v-if="groupedData">
        <div
          v-for="(items, category) in groupedData"
          :key="category"
          class="border-bottom py-3"
        >
          <h2 class="fsize16 font-semibold pb-1">{{ category }}</h2>
          <p
            v-for="item in items"
            :key="item._id"
            class="fsize13 lh16px pb-2 clr-0087d4"
          >
            <a :href="item.link" target="_blank">{{ item.title }}</a>
          </p>
        </div>
      </div>
      <!-- <div class="border-bottom py-3">
        <h2 class="fsize16 font-semibold pb-1">Latest Research</h2>
        <p class="fsize13 lh16px pb-2 clr-0087d4">
          The Mental Health Impact of Caregiving on Family Members
        </p>
        <p class="fsize13 lh16px pb-2 clr-0087d4">
          Emerging Trends in Palliative Care: What Caregivers Need ..
        </p>
        <p class="fsize13 lh16px pb-2 clr-0087d4">
          he Science Behind Compassion Fatigue: What...
        </p>
        <p class="fsize13 lh16px pb-2 clr-0087d4">
          Latest Research on the Emotional Toll of End-of-Life..
        </p>
        <p class="fsize13 lh16px pb-3 clr-0087d4">
          Emerging Trends in Palliative Care: What Caregivers...
        </p>
      </div>
      <div class="border-bottom py-3">
        <h2 class="fsize16 font-semibold pb-1">Explore Resources</h2>
        <p class="fsize13 lh16px pb-2 clr-0087d4">Emotional First Aid</p>
        <p class="fsize13 lh16px pb-2 clr-0087d4">Caregiver Coach Program</p>
        <p class="fsize13 lh16px pb-2 clr-0087d4">Mental health Awareness</p>
        <p class="fsize13 lh16px pb-2 clr-0087d4">Medical Terminology</p>
        <p class="fsize13 lh16px pb-3 clr-0087d4">Caring at Caregiver sath</p>
      </div>
      <div class="border-bottom py-3">
        <h2 class="fsize16 font-semibold pb-1">
          Helpful Links and Collaborations
        </h2>
        <p class="fsize13 lh16px pb-2 clr-0087d4">
          Duis volutpat pulvinar nisi
        </p>
        <p class="fsize13 lh16px pb-2 clr-0087d4">et rutrum nisl rhoncus nec</p>
      </div> -->
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import blogMixin from "../../insights/blogs/mixins/blogMixin";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  mixins: [blogMixin],
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 20,

        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1240: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          820: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },
      blogs: [],
      showLessBlogEnable: true,
      categoryId: null,
      item: {},
    };
  },

  computed: {
    ...mapState("auth", { user: "user" }),
    ...mapState("respitecare", ["get_all_count", "allWithdrawalRequest"]),
    ...mapState("medicalFaq", ["FilteredMedicalFaq"]),
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      categorywisepagesforevent: "categorywisepagesforevent",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),
    ...mapState("affiliate", { affiliateUrlData: "affiliateUrlData" }),
    groupedData() {
      // Ensure data exists
      if (!Array.isArray(this.affiliateUrlData)) return null;

      return this.affiliateUrlData.reduce((acc, item) => {
        if (!acc[item.category]) {
          acc[item.category] = [];
        }
        acc[item.category].push(item);
        return acc;
      }, {});
    },
    filteredBlogs() {
      return this.showLessBlogEnable ? this.blogs.slice(0, 3) : this.blogs;
    },
  },

  methods: {
    readFullBlogs(item) {
      this.item = item;

      this.handleReadMore();
    },
    toggleBlogView() {
      this.showLessBlogEnable = !this.showLessBlogEnable;
    },

    async init() {
      this.pageCategories.forEach((element) => {
        if (element.route.includes("blogs")) this.categoryId = element._id;
      });
      let payload = {
        id: "61adf7f010718313e80bcc4b",
      };
      if (this.$route.name === "medical_cancer") {
        payload.isSelectedCancer = true;
      } else if (this.$route.name === "medical_palliative") {
        payload.isSelectedPalliative = true;
      } else if (this.$route.name === "medical_dementia") {
        payload.isSelectedDementia = true;
      } else if (this.$route.name === "medical_neurologicaldisorders") {
        payload.isSelectedNeurodegenerative = true;
      }

      const { data } = await this.$store.dispatch(
        "cms/GetPagesbyCategoryForBlog",
        payload
      );
      this.blogs = data.data;

      await this.$store.dispatch("affiliate/getUrl", payload);
    },
    showMoreBlogs() {
      this.showLessBlogEnable = false;
    },

    handleClick(URL) {
      let link = "";
      if (URL.includes("http")) {
        link = URL;
      } else {
        link = "https://" + URL;
      }
      return link;
    },
  },

  async mounted() {
    await this.init();
  },
};
</script>
